import { useTheme, Box, Autocomplete, TextField } from "@mui/material";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import TagChip from "./TagChip";

const TagsSelect = ({ tags, selectedTags, onSelectionChange }) => {
  const theme = useTheme();

  return (
    <Box sx={{ minWidth: "300px", width: "100%" }}>
      <Autocomplete
        fullWidth={true}
        multiple
        id="select-multiple-tags"
        onChange={onSelectionChange}
        options={tags}
        getOptionLabel={(tag) => tag.name}
        isOptionEqualToValue={(option, value) => option.code === value.code}
        value={selectedTags}
        filterSelectedOptions
        autoComplete={true}
        autoHighlight={true}
        limitTags={8}
        renderInput={(params) => <TextField {...params} label="Tags" />}
        renderTags={(selectedTags, getTagProps) =>
          selectedTags.map((selectedTag, index) => (
            <TagChip
              label={selectedTag?.name}
              color={selectedTag?.color}
              {...getTagProps({ index })}
            />
          ))
        }
        renderOption={(props, tag, { inputValue }) => {
          const matches = match(tag?.name, inputValue, { insideWords: true });
          const parts = parse(tag?.name, matches);
          return (
            <li {...props} key={tag.code}>
              <TagChip
                label={
                  <div>
                    {parts.map((part, index) => (
                      <span
                        key={index}
                        style={{
                          fontWeight: "bold",
                          color: part.highlight && theme.palette.textMatchColor,
                        }}
                      >
                        {part.text}
                      </span>
                    ))}
                  </div>
                }
                color={tag?.color}
              />
            </li>
          );
        }}
      />
    </Box>
  );
};

export default TagsSelect;